import React from 'react';
import { FiCheckCircle, FiAward, FiUsers, FiTrendingUp, FiClock } from 'react-icons/fi';
import './About.css';

const stats = [
  { icon: <FiUsers />, value: '40+', label: 'Products shipped' },
  { icon: <FiAward />, value: '5', label: 'Industries served' },
  { icon: <FiClock />, value: '< 6 wks', label: 'Avg. MVP timeline' },
  { icon: <FiTrendingUp />, value: '3.4×', label: 'Avg. lead growth' },
];

const principles = [
  'Founder-led by Barani — you talk directly to the person writing your code.',
  'No black boxes — every decision, design and deploy is documented.',
  'Quality is non-negotiable — we test, review and ship with intent.',
  'We measure success by your retention and revenue, not our invoices.',
];

const About = () => {
  return (
    <section id="about" className="about section section--alt">
      <div className="container about-grid">
        <div className="about-media">
          <div className="about-media-frame">
            <img src="/img/abstract-tech.jpg" alt="THINKINGWORLD team and craft" onError={(e) => { e.currentTarget.style.background = 'linear-gradient(135deg,#6b5cff,#06b6d4)'; e.currentTarget.removeAttribute('src'); }} />
          </div>
          <div className="about-media-badge">
            <strong>THINKINGWORLD</strong>
            <span>Founded by Barani · Tamil Nadu, India</span>
          </div>
        </div>

        <div className="about-content">
          <span className="section-eyebrow">About us</span>
          <h2 className="section-title">
            A team that takes <span className="gradient-text">software craft</span> seriously.
          </h2>
          <p className="about-lead">
            Barani started THINKINGWORLD because most agencies optimise for
            handoff, not outcomes. We are builders first. We embed with you,
            understand the business, and ship products that move the needle —
            websites, apps, IoT platforms and the marketing engine behind them.
          </p>

          <ul className="about-principles">
            {principles.map((p) => (
              <li key={p}>
                <FiCheckCircle /> <span>{p}</span>
              </li>
            ))}
          </ul>

          <div className="about-stats">
            {stats.map((s) => (
              <div key={s.label} className="about-stat">
                <div className="about-stat-icon">{s.icon}</div>
                <div>
                  <strong>{s.value}</strong>
                  <span>{s.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
